import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Tooltip, OverlayTrigger, Glyphicon, ButtonGroup } from 'react-bootstrap';

import firebase from '../helpers/firebase';
import { TIMEOFF, TIMEOFF_STATUS, TABLE_NAME } from '../helpers/constants';
import { connect } from 'react-redux';

const db = firebase.database();

class TimeOffRow extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props, context) {
    super(props, context);

    this.state = {
      user: {},
    };

    if (this.props.admin && this.props.timeoff.userId) {
      db.ref(TABLE_NAME.USERS).child(this.props.timeoff.userId).once('value').then((snapshot) => {
        let user = snapshot.val();
        user.id = snapshot.key;
        this.setState({ user: user });
      });
    }

    if (this.props.timeoff.userId && this.props.timeoff.substituteUId) {
      db.ref(TABLE_NAME.USERS).child(this.props.timeoff.substituteUId).once('value').then((snapshot) => {
        let user = snapshot.val();
        user.id = snapshot.key;
        this.setState({ substitute: user });
      });
    }

    if (this.props.review) {
      this.review = this.props.review.bind(this);
    }

    this.cancel = this.cancel.bind(this);
  }


  render() {

    const timeoff = Object.assign({}, this.props.timeoff);
    timeoff.modifiedBy = timeoff.modifiedBy || timeoff.approver;
    timeoff.statusDate = timeoff.statusDate || timeoff.approveOrRejectDate;
    timeoff.user = this.state.user;
    timeoff.display = {
      startDate: moment(timeoff.startDate).format('YYYY-MM-DD (ddd)'),
      endDate: moment(timeoff.endDate).format('YYYY-MM-DD (ddd)'),
      requestDate: timeoff.requestDate ? moment(timeoff.requestDate).format('YYYY-MM-DD (ddd)') : 'N/A',
      statusDate: timeoff.statusDate ? moment(timeoff.statusDate).format('YYYY-MM-DD (ddd)') : 'N/A',
      type: TIMEOFF[timeoff.type.toUpperCase()].fullForm,
    }
    const substitute = this.state.substitute;
    const { display: { startDate, endDate, requestDate, type }, user, days } = timeoff;

    return (
      <tr>
        <td>{type}</td>
        { this.props.admin ? <td>
          <Link to={`/admin/users/${user.id}`}>
            {user.name}
          </Link>
        </td> : null }
        <td>{ substitute !== undefined ? substitute.name : 'Legacy'}</td>
        <td>{startDate}</td>
        <td>{endDate}</td>
        <td>{days}</td>
        <td>{requestDate}</td>
        {!this.props.mini && <TimeOffRowStatus
          admin={this.props.admin}
          timeoff={timeoff}
          review={this.review}
          cancel={this.cancel}
          modify={this.modify}
        />}
      </tr>
    )
  }

  cancel() {
    const statusDate = moment().format('YYYY-MM-DD');
    const modifiedBy = this.props.user;
    return db.ref(TABLE_NAME.TIMEOFFS).child(this.props.timeoff.id).update({
      status: TIMEOFF_STATUS.CANCELLED,
      statusDate,
      modifiedBy
    }).then(() => {
      // update handled in getTimeOffHistory
    });
  }
}

class StatusWithTooltip extends Component {
  render() {
    if (!this.props.tooltip) {
      return <div>{this.props.children}</div>
    }

    let tooltip = <Tooltip id={this.props.id}>{this.props.tooltip}</Tooltip>;

    return (
      <div>
        {this.props.children}
        <OverlayTrigger
          overlay={tooltip} placement="top"
          delayShow={150} delayHide={150}
        >
          <a
            style={{paddingLeft: '5px'}}
            href={this.props.href}
          >
            <Glyphicon glyph="file" />
          </a>
        </OverlayTrigger>
      </div>
    );
  }
}

class TimeOffRowStatus extends Component {

  render() {
    const {admin, review, timeoff, cancel} = this.props;

    let statusString = `${timeoff.status}
      ${(timeoff.modifiedBy ? (' by ' + timeoff.modifiedBy.name) : '')}
      ${(timeoff.display.statusDate ? (' on ' + timeoff.display.statusDate) : '')}`;

    if (
      (
        timeoff.type === TIMEOFF.PSL.type ||
        timeoff.type === TIMEOFF.UPSL.type ||
        timeoff.type === TIMEOFF.HPSL.type ||
        timeoff.type === TIMEOFF.WFH.type
      ) &&
      timeoff.status === TIMEOFF_STATUS.APPROVED
    ) {
      statusString = 'Approved automatically';
    }

    if (!admin) {
      return <td className="capitalize">
        {statusString}
        {
          moment(timeoff.startDate).isSameOrAfter(moment(), "day") ? (
            <ButtonGroup>
              { timeoff.status !== 'canceled'
                ? <Button bsStyle="warning" onClick={cancel}>Cancel</Button>
                : ''
              }
              <Link to={`/form/${this.props.timeoff.id}`}>
                <Button bsStyle="info">Modify</Button>
              </Link>
            </ButtonGroup>
          )
            : ''
        }
      </td>
    }

    if (timeoff.status === TIMEOFF_STATUS.PENDING) {
      return <td>
        <Button bsStyle="primary" onClick={() => { review(timeoff) }}>Review</Button>
      </td>;
    }

    return <td className="capitalize">
      <StatusWithTooltip tooltip={timeoff.note} href="#" id={'tooltip-' + timeoff.id}>
        {statusString}
      </StatusWithTooltip>
    </td>;

  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(TimeOffRow);



// WEBPACK FOOTER //
// ./src/components/TimeOffRow.js